import { useDeleteFromBasketMutation } from 'autogen/swagger/all/hooks';
import { Delete } from 'autogen/translation-keys/trans-website-shared';
import { Button } from 'components/Button';
import { updateBasket } from 'components/basket/shared/basket';
import { useTranslation } from 'react-i18next';
import track from 'modules/tracking/dataLayer';

export default function RemoveItemButton({ productId, ...restProps }: { productId: number }) {
    const { t } = useTranslation();
    const { mutateAsync } = useDeleteFromBasketMutation({
        onSuccess: (response) => {
            updateBasket();
            response.dataLayerDto && track(response.dataLayerDto);
        }
    });

    return (
        <Button onClick={() => mutateAsync({ params: { productId } })} variant="secondary" {...restProps}>
            {t(Delete)}
        </Button>
    );
}
